<!--
 * @Author: your name
 * @Date: 2021-07-22 17:18:42
 * @LastEditTime: 2021-07-22 17:30:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\indexes\inquiry\add.vue
-->
<template>
  <inquiry-operate />
</template>
<script>
import inquiryOperate from './components/inquiryOperate';
export default {
  name: 'SettingInquiryAdd',
  components: {
    inquiryOperate,
  },
  data() {
    return {};
  },
};
</script>
